const React = require('react');
const { FeedbackThumbs } = require('dx-feedback-utils');
const createHTTPClient = require('./httpClient');
const { getEventTracker } = require('../../../utils/event-tracker');

module.exports = function FeedbackThumbsAdapter({ siteId, lang }) {
  const Tracker = getEventTracker();

  if (typeof window === typeof undefined) {
    return null;
  }

  const HTTPClient = createHTTPClient();
  const userId = window?.__PRELOADED_STATE__?.userData?.id;

  return (
    <FeedbackThumbs
      isCard
      lang={lang}
      userId={userId}
      siteId={siteId}
      isLogged={Boolean(userId)}
      reportErrorURL={`${window.location.origin}/developers/report?source=dx-devsite-feedback`}
      onSendReasons={(data) => new Promise((resolve, reject) => {
        (async () => {
          try {
            const response = await HTTPClient.post('/feedback', { data });
            // ------------------- tracks
            Tracker.melidata.send('/developers/feedback', {
              feedback_obs: 'not_apply',
              feedback_response: data.satisfaction,
              feedback_type: data?.additional_info?.reasons?.[0],
            }, {
              autoDocsRefInfo: true,
            });

            Tracker.send(`mpdevelopers/${data.satisfaction}_FEEDBACK`);
            Tracker.send(`mpdevelopers/feedback/${data.satisfaction}`, data);
            // -------------------
            resolve({ metrics_id: response.data.id });
          } catch (error) {
            console.error(error);
            Tracker.send('mpdevelopers/feedback/request_error', error);
            reject(error);
          }
        })();
      })}
      onSendComment={(data) => new Promise((resolve, reject) => {
        (async () => {
          try {
            await HTTPClient.put(`/feedback/${data.metrics_id}`, { data });
            // ------------------- track
            Tracker.melidata.send('/developers/feedback', {
              feedback_response: data.satisfaction,
              feedback_type: data?.additional_info?.reasons?.[0],
              feedback_obs: data?.additional_info?.comment || 'not_apply',
              feedback_allowcontact: data?.additional_info?.email_agreement || 'not_apply',
            }, {
              autoDocsRefInfo: true,
            });

            Tracker.send(`mpdevelopers/${data.satisfaction}_FEEDBACK`);
            Tracker.send(`mpdevelopers/feedback/comment_${data.satisfaction}`);
            Tracker.send(`mpdevelopers/feedback/email_${data?.additional_info?.email_agreement}`);
            // -------------------
            resolve(true);
          } catch (error) {
            console.error(error);
            Tracker.send('mpdevelopers/feedback/request_error', error);
            reject(error);
          }
        })();
      })}
      onClickThumb={(value) => {
        Tracker.send(`mpdevelopers/feedback/thumb/${value}`);

        Tracker.melidata.send('/developers/feedback/thumb', {
          thumb: value || 'not_apply',
        }, {
          autoDocsRefInfo: true,
        });
      }}
      onOpenModal={() => {
        Tracker.send('mpdevelopers/feedback/modal-opened');

        Tracker.melidata.send('/developers/feedback/modal_opened', {}, {
          autoDocsRefInfo: true,
        });
      }}
      onCloseModal={() => {
        Tracker.send('mpdevelopers/feedback/modal-closed');

        Tracker.melidata.send('/developers/feedback/modal_closed', {}, {
          autoDocsRefInfo: true,
        });
      }}
      onClickReport={() => {
        Tracker.send('mpdevelopers/feedback/bugreport');
      }}
      onErrorView={() => {
        Tracker.send('mpdevelopers/feedback/error');

        Tracker.melidata.send('/developers/feedback/error', {}, {
          autoDocsRefInfo: true,
        });
      }}
      onClickReset={() => {
        Tracker.send('mpdevelopers/feedback/reset');

        Tracker.melidata.send('/developers/feedback/reset', {}, {
          autoDocsRefInfo: true,
        });
      }}
      onSkipComment={() => {
        Tracker.send('mpdevelopers/feedback/skip_comment');

        Tracker.melidata.send('/developers/feedback/skip_comment', {}, {
          autoDocsRefInfo: true,
        });
      }}
    />
  );
};
